<template>
    <page-content>
        <div slot="header">
            <h4 class="moduldTit">考核评分表设置</h4>
            <div class="formsettingHead">
                <el-select v-model="selectDepartment" placeholder="请选择部门" size="mini" clearable>
                    <el-option v-for="department in departmentList" :key="department.id" :label="department.unit_name" :value="department.id"></el-option>
                </el-select>
                <!-- <el-button type="primary" @click="getEvalForm" size="mini">获取部门评分表</el-button> -->
                <el-button type="primary" style="margin-left:20px;" @click="createEvalForm" size="mini">创建考核评分表</el-button>
            </div>
        </div>
        <div slot="content">
            <template>
                <el-table :data="currentDepEvalForms" v-loading="tableLoading" border style="width: 600px;">
                    <el-table-column prop="index" label="序号" header-align="center" align="center" type="index" width="119"></el-table-column>
                    <el-table-column prop="name" label="名称" width="300" header-align="center" align="center"></el-table-column>
                    <el-table-column label="操作" width="180"  header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="editEvalForm(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="delEvalForm(scope.row)" type="text" size="small" style="margin-left:20px">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import {getDepartmentList,getFromTempList,createFromTemp,deleteFromTemp} from './requestFun.js'

export default {
    data(){
        return{
            selectDepartment: null,
            selectDepartment_name: null,
            evaluationForms:[],
            departmentList: [],
            currentDepEvalForms: [],
            tableLoading:false,
        }
    },
    created(){
        this.getDepartments();
        this.getEvalForm();
    },
    components:{
        pageContent
    },
    watch: {
        evaluationForms: {
            deep:true,
            handler: function(val, oldVal){
                if(this.selectDepartment){
                    this.currentDepEvalForms = val.filter((item) => {
                        return item.department_id == this.selectDepartment && item.is_activated == 1;
                    })
                }else {
                    this.currentDepEvalForms = val.filter((item) => {
                        return item.is_activated == 1;
                    })
                }
            }
        },
        selectDepartment(val){
            if(val){
                this.currentDepEvalForms = this.evaluationForms.filter((item) => {
                    return item.department_id == val && item.is_activated == 1;
                })
                for(let i = 0; i < this.departmentList.length; i++){
                    if(this.departmentList[i].id == this.selectDepartment){
                        this.selectDepartment_name = this.departmentList[i].unit_name;
                        break;
                    }
                }
            }else {
                this.currentDepEvalForms = this.evaluationForms;
            }
        }
    },
    methods:{
        // 获取部门数据
        getDepartments(){
            this.tableLoading=true;
            getDepartmentList().then((res)=>{
                if(res.status === 200){
                    if(res.data.data){
                        this.departmentList = res.data.data;
                    }
                }
                this.tableLoading=false;
            }).catch((err)=>{
                console.log(err)
                this.tableLoading=false;
            })
        },
        // 获取评分表模板
        getEvalForm(){
            getFromTempList().then((res)=>{
                if(res.status === 200){
                    if(res.data.data){
                        this.evaluationForms = res.data.data;
                    }
                    
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 创建表格模板
		createEvalForm(){
			if(this.selectDepartment){
                this.$prompt('请输入考核评分表名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    createFromTemp({department_id: this.selectDepartment,template_name: value}).then((res)=>{
                        if(res.status === 200){
                            this.$message({
                                type: 'success',
                                message: value + '创建成功'
                            });
                        }
                        this.$router.push({ path: '/setAssessFormWrite', query: {departmentName: this.selectDepartment_name,formName: value,formId: res.data.data}});
                        // this.getEvalForm()
                    }).catch((err)=>{
                        console.log(err)
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消考核评分表创建'
                    });
                });
			}else {
				this.$message({type: 'error',message: '请选择部门'})
            }
        },
        // 修改表格模板
        editEvalForm(row) {
            this.$router.push({ path: '/setAssessFormWrite', query: {departmentName: this.selectDepartment_name,formName: row.name,formId: row.id}});
            // this.$router.push({name:'assessFormWrite', params: {departmentName: departmentName,formName: row.name,formId: row.id}});
        },
        // 删除表格模板
        delEvalForm(row){
            deleteFromTemp({template_id:row.id}).then((res)=>{
                if(res.status === 200){
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.getEvalForm()
                }
            }).catch((err)=>{
                console.log(err)
                this.$message({
                    type: 'error',
                    message: '删除失败'
                });
            })
        },
        // 下拉选择事件回调函数
        handleCommand(command) {
            // this.sele=command;
        }
    }
}
</script>
<style scoped>

</style>


